import React from 'react';
import PropTypes from 'prop-types';
import "./rscard.css"

const RsCardImg = ({ title, description, iconClass }) => {
  return (
    <div className="card rs-card  border-full mt-4">
      <div className="card-body">
        <div className="d-flex">
          <div className="flex-grow-1">
            <h3 className="mb-0 font-size-18">{title}</h3>
            <h4 className="mb-0">{description}</h4>
          </div>
          <div className="mini-stat-icon avatar-sm rounded-circle  align-self-center">
            <span className="">
              <img src={iconClass} width={36} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

RsCardImg.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
};

RsCardImg.defaultProps = {
  title: 'Default Title',
  description: 'Default Description',
  iconClass: 'bx-default-icon',
};

export default RsCardImg;